var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('KTWidget2')],1),_c('div',{staticClass:"col-lg-6"},[_c('KTWidget14')],1)]),_c('div',{staticClass:"card card-custom gutter-b"},[_c('KTWidget3')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }